$(function(){
  $('.js-faq-accordion dl dt').click(function(){
    $(this).toggleClass('active');
    $(this).next('dd').slideToggle();
  });
});

$(function() {
  $('.js-tab').on('click', function() {
    $('.js-tab, .js-panel').removeClass('active');
  
    $(this).addClass('active');
     
    var index = $('.js-tab').index(this);
    $('.js-panel').eq(index).addClass('active');
  });
});

$(function() {
  $('.js-option-size').on('click', function() {
    $('.js-option-size, .js-unit-table').removeClass('active');
  
    $(this).addClass('active');
     
    var index = $('.js-option-size').index(this);
    $('.js-unit-table').eq(index).addClass('active');
  });
});